import { Col, GridContainer } from "@amzn/stencil-react-components/layout";
import { PaginationVariant } from "@amzn/stencil-react-components/pagination";
import { Text } from "@amzn/stencil-react-components/text";
import { Pagination } from "@amzn/uxm-stencil-react-components/lib/src/stencil";
import { getString } from "common/uistringlabels/uiStringUtils";
import React, { FC, useState } from "react";

import EXPLORATION_CARDS from "../../../../../public/features/aiforme/exploration-cards.json";
import { AiExplorationCard } from "./AiExplorationCard";

const CARDS_PER_PAGE = 2;

/**
 * Section component displaying the "Amazon AI Exploration" cards
 * with dotted pagination.
 */
export const AiExplorationSection: FC = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(EXPLORATION_CARDS.length / CARDS_PER_PAGE);
  const startIndex = (currentPage - 1) * CARDS_PER_PAGE;
  const displayedCards = EXPLORATION_CARDS.slice(startIndex, startIndex + CARDS_PER_PAGE);

  return (
    <Col alignItems="center" rowGap={32} data-testid="ai-exploration-section">
      <Text fontSize="T400" fontWeight="bold" data-testid="ai-exploration-heading">
        {getString("aiForMe.landingPage.aiExplorationSection.sectionTitle")}
      </Text>

      <Col rowGap={24} alignItems="center" style={{ width: "100%" }}>
        <GridContainer>
          {displayedCards.map((card, idx) => (
            <AiExplorationCard key={startIndex + idx} {...card} index={startIndex + idx} />
          ))}
        </GridContainer>

        {totalPages > 1 && (
          <Pagination
            numberOfPages={totalPages}
            selectedPage={currentPage}
            onPageSelect={setCurrentPage}
            variant={PaginationVariant.Dotted}
            touchpoint="ai-exploration-pagination"
          />
        )}
      </Col>
    </Col>
  );
};
